import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import CommercialHeader from "@/components/commercial/CommercialHeader";
import { api, fmtDateTime } from "@/lib/commercialApi";
import { APPOINTMENT_STATUSES } from "@/lib/commercialStages";
import { Loader2 } from "lucide-react";

export default function ComAppointments() {
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState("");
  const [syncing, setSyncing] = useState(false);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);
  async function load() {
    setRows(null);
    const params = status ? { status } : {};
    const r = await api.get("/appointments", { params });
    setRows(r.data.appointments);
  }
  async function updateStatus(id, s) {
    try { await api.patch(`/appointments/${id}`, { status: s }); load(); toast.success("Mis à jour"); }
    catch { toast.error("Erreur"); }
  }
  async function syncFromGoogle() {
    setSyncing(true);
    try {
      const r = await api.post("/sync-from-google");
      const d = r.data;
      toast.success(`${d.created} RDV importés · ${d.matched_prospect} rattachés à un prospect · ${d.skipped_existing} déjà présents`);
      load();
    } catch { toast.error("Sync Google échouée"); }
    finally { setSyncing(false); }
  }
  return (
    <div className="min-h-screen bg-brand-paper">
      <CommercialHeader />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
          <div>
            <div className="eyebrow mb-1">Agenda commercial</div>
            <h1 className="font-display text-3xl text-brand-ink">Rendez-vous</h1>
          </div>
          <div className="flex gap-2">
            <select value={status} onChange={(e) => setStatus(e.target.value)} className="h-9 px-3 text-xs rounded-md border border-brand-line bg-white">
              <option value="">Tous statuts</option>
              {APPOINTMENT_STATUSES.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
            </select>
            <button
              onClick={syncFromGoogle} disabled={syncing}
              data-testid="btn-sync-google"
              className="inline-flex items-center gap-1.5 h-9 px-3 text-xs rounded-md border border-brand-line bg-white hover:border-brand-ink/25 text-brand-ink">
              {syncing ? "Sync…" : "Importer depuis Google Calendar"}
            </button>
          </div>
        </div>
        {rows === null ? <Loader2 className="h-4 w-4 animate-spin text-brand-subtle" />
          : rows.length === 0 ? (
          <div className="rounded-lg border border-brand-line bg-white p-10 text-center max-w-xl mx-auto">
            <div className="font-display text-xl text-brand-ink">Aucun rendez-vous</div>
            <p className="mt-2 text-sm text-brand-subtle">
              Les rendez-vous commerciaux apparaissent ici dès qu'un prospect accepte un RDV ou qu'un événement Google Calendar est importé.
            </p>
            <div className="mt-5 flex gap-2 justify-center flex-wrap">
              <Link to="/prospection" className="inline-flex items-center h-9 px-4 rounded-md bg-brand-ink text-white text-xs hover:bg-brand-moss">Aller dans Prospection</Link>
              <button onClick={syncFromGoogle} disabled={syncing} className="inline-flex items-center h-9 px-4 rounded-md border border-brand-line bg-white text-xs text-brand-ink hover:border-brand-ink/30">
                {syncing ? "Sync…" : "Importer depuis Google Calendar"}
              </button>
            </div>
          </div>
        ) : (
          <div className="rounded-lg border border-brand-line bg-white divide-y divide-brand-line">
            {rows.map((a) => (
              <div key={a.id} className="p-4 flex items-center justify-between gap-3 text-sm flex-wrap">
                <div>
                  <Link to={`/commercial/opportunites/${a.opportunity_id}`} className="font-medium text-brand-ink hover:underline">
                    {fmtDateTime(a.scheduled_at)} · {a.interlocuteur_nom}
                  </Link>
                  <div className="text-xs text-brand-subtle mt-0.5">{a.besoin} · {a.commercial || "—"}</div>
                </div>
                <select value={a.status} onChange={(e) => updateStatus(a.id, e.target.value)} className="h-8 px-2 text-xs rounded-md border border-brand-line bg-white" data-testid={`appt-status-${a.id}`}>
                  {APPOINTMENT_STATUSES.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
                </select>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
